import { render, staticRenderFns } from "./addMeta.vue?vue&type=template&id=388e4b94&scoped=true&"
import script from "./addMeta.vue?vue&type=script&lang=js&"
export * from "./addMeta.vue?vue&type=script&lang=js&"
import style0 from "./addMeta.vue?vue&type=style&index=0&id=388e4b94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388e4b94",
  null
  
)

export default component.exports